import { configureStore } from '@reduxjs/toolkit';
import rfqReducer from './rfqSlice';

export const store = configureStore({
    reducer: {
        rfq: rfqReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
